import React, { Component } from 'react';
import { Form, Icon, Input, Button, Spin } from 'antd';
import HTTPStatus from 'http-status';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchLogin } from '../../commons/consultesServidor';
import { crearMissatgeError } from '../../commons/missatgeServidor';
import { guardarToken } from '../../commons/gestioWebToken';
import { rutaArrel } from '../../routes/routeConstants';
import { loginOmplirDadesUsuariRegistrat } from '../../actions/login';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import { existeixUsuariRegistrat } from '../../selectors/selector_login';

const FormItem = Form.Item;

class Login extends Component {

    constructor(props) {
        super(props);
        this.enviarFormulari = this.enviarFormulari.bind(this);
        this.gestionarExitConsultaLogin = this.gestionarExitConsultaLogin.bind(this);
        this.gestionarErrorConsultaLogin = this.gestionarErrorConsultaLogin.bind(this);
        this.nomCampUsuari = 'usuari';
        this.nomCampContrasenya = 'contrasenya';

        this.state = {
            consultaLoginEnCurs: false
        };
    }

    componentDidMount() {
        if (this.props.existeixUsuariRegistrat) {
            this.props.router.push(rutaArrel);
        }
    }

    gestionarExitConsultaLogin(respostaServidor) {
        const { token, payload } = respostaServidor;
        guardarToken(token);
        this.props.loginOmplirDadesUsuariRegistrat(payload);
        this.props.router.push(rutaArrel);
    }

    gestionarErrorConsultaLogin(respostaServidor) {

        this.setState({...this.state, consultaLoginEnCurs: false });

        if (respostaServidor.status !== HTTPStatus.UNAUTHORIZED) {
            crearMissatgeError();
            return;
        }

        const nomCampAmbErrors = respostaServidor.body.camp;
        const missatgeError = respostaServidor.body.missatge;

        if (nomCampAmbErrors !== this.nomCampUsuari && nomCampAmbErrors !== this.nomCampContrasenya) {
            crearMissatgeError();
            return;
        }

        this.props.form.setFields({
            [nomCampAmbErrors]: { value: this.props.form.getFieldValue(nomCampAmbErrors), errors: [new Error(missatgeError)]}
        });
    }

    enviarFormulari(event) {
        event.preventDefault();

        this.props.form.validateFields((error, values) => {
            if (!error) {
                this.setState({...this.state, consultaLoginEnCurs: true });
                fetchLogin(values)
                    .then(this.gestionarExitConsultaLogin, this.gestionarErrorConsultaLogin);
            }
        });
    }

    render() {

        if (this.props.existeixUsuariRegistrat) {
            return null;
        }

        const { getFieldDecorator } = this.props.form;

        const iconaInputUsuari = <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />;
        const iconaInputContrasenya = <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />;
        const inputUsuari = <Input size='large' prefix={iconaInputUsuari} placeholder='Usuari' />;
        const inputContrasenya = <Input size='large' prefix={iconaInputContrasenya} type='password' placeholder='Contrasenya' />;
        const opcionsInputUsuari = {
            rules: [{ required: true, message: 'El codi d\'usuari/ària és obligatori' }]
        };
        const opcionsInputPassword = {
            rules: [{ required: true, message: 'La contrasenya és obligatòria' }]
        };

        return (
            <Spin spinning={this.state.consultaLoginEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER} tip='Iniciant sessió...'>
                <Form onSubmit={this.enviarFormulari}>
                    <FormItem>
                        {getFieldDecorator(this.nomCampUsuari, opcionsInputUsuari)(inputUsuari)}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator(this.nomCampContrasenya, opcionsInputPassword)(inputContrasenya)}
                    </FormItem>
                    <FormItem>
                        <Button
                            className='login-formulari-boto-submit'
                            type="primary"
                            size='large'
                            htmlType="submit"
                        >
                            Iniciar sessió
                        </Button>
                    </FormItem>
                </Form>
            </Spin>
        );
    }
}

const mapsStateToProps = (state) => {
    return {
        existeixUsuariRegistrat: existeixUsuariRegistrat(state)
    };
};

Login.propTypes = {
    form: PropTypes.object, //Prop passada automàticament per la funció Form.create()
    existeixUsuariRegistrat: PropTypes.bool,
    router: PropTypes.object,
    loginOmplirDadesUsuariRegistrat: PropTypes.func
};

export default connect(mapsStateToProps, {loginOmplirDadesUsuariRegistrat})(Form.create()(Login));


// WEBPACK FOOTER //
// ./src/components/login/loginFormulari.js